import * as actions from '../Actions/Types';

export const typesReducer = (state = {}, action) => {
    switch (action.type) {
        case actions.GET_TYPES_DATA_REQUESTED:
            return {...state, isLoading: true};
        case actions.GET_TYPES_DATA_DONE:
            return {...state, isLoading: false, types: action.payload};
        case actions.GET_TYPES_DATA_FAILED:
            return {...state, isLoading: false, isError: true, error: action.payload};
        default:
            return state;
    }
    };